module.exports = __webpack_public_path__ + "73f8fe3e73bc8ca6fa7713c387a8cbfa.png";